<template>
    <p>This is a table showing a list of assessment activation statuses</p>
</template>